<template>
  <div v-if="visible" class="list-search-item">
    <div class="item-label">{{label}}</div>
    <div class="item-con">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {filterItemProps} from './index.js'

  export default {
    name: 'filter-item',
    props: filterItemProps,
    data () {
      return {
        visible: false,
        parentEl: null,
        positionLen: null,
        positionInd: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$parent.$options.name !== 'filter') {
          this.parentEl = this.getParent('filter')
        }
        this.emitHandle('create')
      })
    },
    beforeDestroy () {
      this.emitHandle('destroy')
    },
    watch: {
      '$parent.lineMaxLen': {
        handler (nvl) {
          this.positionLen = nvl
        },
        deep: true,
        default: true
      },
      '$parent.slotSearch': {
        handler (nvl) {
          this.positionInd = nvl.findIndex(val => val?.componentOptions?.propsData?.label === this.label)
        }
      }
    },
    computed: {
      showLenNum () {
        return ((this.positionInd + 1) / this.positionLen) % 1 === 0
      }
    },
    methods: {
      emitHandle (event) {
        this.parentEl ? this.parentEl.$emit(event) : this.$parent.$emit(event)
      },
      updateVisible (flag) {
        this.visible = flag
      },
      getParent (tagName) {
        let parent = this.$parent || this.$root
        let name = parent.$options.name
        while (parent && (!name || name !== tagName)) {
          parent = parent.$parent

          if (parent) {
            name = parent.$options.name
          }
        }

        return parent
      }
    }
  }
</script>

<style scoped lang="scss">
  .list-search-item {
    display: inline-block;
    vertical-align: text-top;
    width: 230px;
    margin: 0 24px 16px 0;
    font-size: 12px;

    &:last-child {
      margin-right: 0;
    }

    .item-label {
      font-size: 14px;
      color: #242F57;
      line-height: 20px;
      // font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      margin-bottom: 4px;
      overflow: hidden;
    }
  }

  .item-con {
    width: 100%;
    letter-spacing: 0;
    word-spacing: 0;
    ::v-deep .el-input__icon {
      line-height: 32px;
    }
    ::v-deep .el-range__close-icon, ::v-deep .el-range__icon {
      line-height: 26px;
    }
    .el-input, .el-select, input {
      min-height: 32px;
      border-radius: 4px;
    }

    ::v-deep .el-input__inner {
      min-height: 32px;
      border-radius: 4px;
      font-size: 12px !important;
    }

    .el-input, .el-select, .el-date-editor--daterange, .el-date-editor, .el-cascader {
      width: 100%;
      min-height: 32px;
      border-radius: 4px;

      input {
        min-height: 32px;
        border-radius: 4px;
        font-size: 12px;
      }
    }

    ::v-deep .el-input__validateIcon {
      display: none;
    }

    .el-select .el-input--suffix {
      width: 100%;
    }

    ::v-deep .sy-list-search-item-separator {
      float: left;
      font-size: 12px;
      margin-top: 7px;
      width: 20px;
      text-align: center;

    }

    ::v-deep .sy-date-editor {
      float: left;
      width: 105px;
    }
  }
</style>
<style lang="scss">
  .sy-date-editor {
    .el-input__prefix {
      display: none;
    }

    .el-input__inner {
      padding-left: 8px !important;
      padding-right: 20px;
    }
  }
</style>
